export const TYPE_NEW = 'CREATED';

export const TYPE_RESCHEDULED = 'RESCHEDULED';

export const TYPE_CANCELLED = 'CANCELLED';
